import apiClient from '@/lib/axios';

export const getAuditTrail = async (params = {}) => {
  const res = await apiClient.get('/audit-logs', { params });
  return res.data.data;
};

export const getAuditLogById = async (id) => {
  const res = await apiClient.get(`/audit-logs/${id}`);
  return res.data.data;
};
